import React from "react";
import "./functional-document.css";
import CommonImage from "../CommonComponent/CommonImage";
import componentDisplayExtension from "../../commonUtils/ComponentDisplayExtension";
import { isMobile } from "react-device-detect";
import CONFIG_OBJECT from "../../config/config";
import App_Constants from "../../app-constants/App_Constants";
import { postDataFetcher } from "../../dataFetcher";
import configData from "../../temp/config";

const FunctionalDocument = (props) => {
  const openDocument = () => {
    let itemId = props.fields.link.value.id.toLowerCase();
    postDataFetcher(
      `${CONFIG_OBJECT.FUNCTIONAL_DOCUMENT_REST_URL}/${itemId}${
        App_Constants.SC_API_KEY
      }&sc_lang=${localStorage.getItem("language")}`
    ).then(
      (response) => {
        if (response.data.HasError) {
        } else {
          if (document != null) {
            let apiURL = `${configData.sitecoreApiHost}${CONFIG_OBJECT.FUNCTIONAL_DOCUMENT_REST_URL}`;
            document.FunctionalDocForm.action = `${apiURL}?itemId=${itemId}&sc_apikey=${configData.sitecoreApiKey}`;
            document.FunctionalDocForm.submit();
            document.FunctionalDocForm.action = "";
          }
        }
      },
      (err) => {
        console.log(err);
      }
    );
  };

  //IFRAME: Code to check displaying based on querystring
  if (!componentDisplayExtension.isDisplay(props)) {
    return <></>;
  }
  //----------------------------------------------

  return (
    <div className="swagger-document-link doc-download">
      <form method="post" name="FunctionalDocForm" id="FunctionalDocForm">
        <a onClick={openDocument}>
          <CommonImage imageIcon={props.fields.icon.value.src} />
          {!isMobile && <span>{props.fields.title.value}</span>}
        </a>
      </form>
    </div>
  );
};

export default FunctionalDocument;
